import { render, staticRenderFns } from "./RelationImportProcess.vue?vue&type=template&id=65bc0c94"
import script from "./RelationImportProcess.vue?vue&type=script&lang=js"
export * from "./RelationImportProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports